import * as types from '../actions/actionTypes';

const initialState = {
  deposits: [],
  fundsAvailable: 0,
};

export const depositsReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.LOAD_DEPOSITS: {
    return {
      ...state,
      deposits: action.deposits,
    };
  }
  case types.LOAD_FUNDS_AVAILABLE: {
    return {
      ...state,
      fundsAvailable: action.fundsAvailable,
    };
  }
  default:
    return state;
  }
};
